import type { ComponentChildren } from 'preact';
import { cn } from '@/lib/cn';

export interface SectionProps {
  title?: ComponentChildren;
  description?: ComponentChildren;
  actions?: ComponentChildren;
  kicker?: ComponentChildren;
  rail?: ComponentChildren;
  children?: ComponentChildren;
  className?: string;
}

export function Section({ title, description, actions, kicker, rail, children, className }: SectionProps) {
  return (
    <section className={cn('flex flex-col gap-6', className)}>
      {(title || description || actions || kicker) && (
        <header className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex min-w-0 flex-col gap-1.5">
            {kicker ? (
              <span className="text-2xs font-semibold uppercase tracking-display text-fg-faint">
                {kicker}
              </span>
            ) : null}
            {title ? (
              <h2 className="text-15 font-semibold tracking-normal text-fg-strong">{title}</h2>
            ) : null}
            {description ? <p className="max-w-3xl text-13 leading-5 text-fg-muted">{description}</p> : null}
          </div>
          {(actions || rail) ? (
            <div className="flex shrink-0 items-center gap-3">
              {actions ? <div className="flex flex-wrap items-center justify-end gap-2">{actions}</div> : null}
              {rail}
            </div>
          ) : null}
        </header>
      )}
      {children}
    </section>
  );
}
